/**
 * Playground SpecificAI catalog labels. Trained models are identified by
 * distillation-event id, but the Add Model dropdown shows the version number
 * (``V1.0``) — the same format used on the Trainings and Tasks pages.
 */
export function formatSpecificAIVersionLabel(version) {
    if (version == null || version === '') return null;
    const n = Number(version);
    if (!Number.isFinite(n)) return null;
    const text = n.toFixed(0) === String(n) ? `${n}.0` : String(n);
    return `V${text}`;
}

export function specificAIModelLabel(entry) {
    return (
        formatSpecificAIVersionLabel(entry?.version)
        || entry?.display_name
        || entry?.id
        || ''
    );
}

/** Provider-section order: SpecificAI (Playground only), then recommended, then A–Z. */
export function compareProviderSectionOrder(a, b, { specificAIProvider, recommendedProviderId, labelFor }) {
    if (a === specificAIProvider && b !== specificAIProvider) return -1;
    if (b === specificAIProvider && a !== specificAIProvider) return 1;
    if (a === recommendedProviderId) return -1;
    if (b === recommendedProviderId) return 1;
    return labelFor(a).localeCompare(labelFor(b));
}
